export default "__VITE_ASSET__pQgq1PzM__"